import { objectAssign } from '@dazn/peng-html5-tools-utils';
/**
 * Creates a general purpose set of defaults for use with any back-end service.
 *
 * NB: By default, Hyper will not retry requests.
 *
 * Can be overridden if needed.
 */
var createServiceRetryConfig = function (overrides) {
    if (overrides === void 0) { overrides = {}; }
    return objectAssign({ maxRetryCount: 2, baseDelayMs: 500 }, overrides);
};
export { createServiceRetryConfig };
//# sourceMappingURL=createServiceRetryConfig.js.map